import { render, staticRenderFns } from "./SendNewsSelectDuration.vue?vue&type=template&id=04568044"
import script from "./SendNewsSelectDuration.vue?vue&type=script&lang=js"
export * from "./SendNewsSelectDuration.vue?vue&type=script&lang=js"
import style0 from "./SendNewsSelectDuration.vue?vue&type=style&index=0&id=04568044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports